import { useQuery } from "@tanstack/react-query"
import axios from "axios"
import { auth } from "@/lib/firebase"

export const useURLBlobFromUrl = (url: string) => {
	return useQuery({
		queryKey: ["urlBlobFromUrl", url],
		queryFn: async () => {
			const backendUrl = import.meta.env.VITE_API_URL
			
			// Check if the URL is from our API and needs auth
			const isApiUrl = backendUrl && url.startsWith(backendUrl)
			
			let headers = {}
			if (isApiUrl) {
				const user = auth.currentUser
				if (user) {
					const token = await user.getIdToken()
					headers = { Authorization: `Bearer ${token}` }
				}
			}
			
			const response = await axios.get(url, { 
				responseType: "blob",
				headers
			})
			const blob = new Blob([response.data], {
				type: response.headers["content-type"],
			})
			return URL.createObjectURL(blob)
		},
		enabled: !!url,
	})
}
